import type {
  VitalsAggregateMeasureResult,
  VitalsAggregateResult,
  VitalsMeasurementRequest,
  VitalsQueryParams,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export type VitalsAggregateMergedResult = Omit<VitalsAggregateResult, 'next'>;

export class VitalsApi {
  public async getVitals(
    params: VitalsQueryParams,
  ): Promise<VitalsAggregateMergedResult> {
    return await trpcClient.vitals.getByPatient.query(params);
  }

  public async getTracking(
    params: VitalsQueryParams,
  ): Promise<VitalsAggregateMergedResult> {
    return await trpcClient.vitals.getByTracking.query(params);
  }

  public async getVitalsByMeasurement(
    params: VitalsMeasurementRequest,
  ): Promise<VitalsAggregateMeasureResult> {
    return await trpcClient.vitals.getByName.query({
      ...params,
    });
  }
}
